import { sizes } from "../utils";
import type { MontaSVGProps } from "../types";
const LinkedIn = ({
  size = "medium",
  color = "inherit",
  ...props
}: MontaSVGProps) => {
  const computedSize = sizes[size] || size;
  props.style = {
    ...props.style,
    color
  };
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill={color}
      viewBox="0 0 25 24"
      width={computedSize}
      height={computedSize}
      {...props}
    >
      <g fill="#FEFEFE" clipPath="url(#LinkedIn_svg__a)">
        <path d="M13.292 10.135c.334-.376.601-.755.95-1.077a5.22 5.22 0 0 1 3.752-1.483 8.8 8.8 0 0 1 2.361.301c1.763.509 2.786 1.724 3.276 3.445.324 1.285.471 2.61.436 3.934v8.424c0 .261-.072.33-.33.33a259 259 0 0 0-4.335 0c-.256 0-.301-.078-.301-.318v-8.005a7.2 7.2 0 0 0-.235-1.989c-.346-1.203-1.203-1.805-2.458-1.742-1.711.09-2.605.939-2.821 2.68q-.08.624-.079 1.252v7.789c0 .258-.066.337-.33.334H8.813c-.235 0-.301-.06-.301-.301V8.29c0-.255.08-.316.322-.3h4.148c.253 0 .319.078.3.318 0 .596.01 1.213.01 1.826M5.372 16.007v7.63c0 .282-.07.366-.361.363H.676c-.232 0-.301-.054-.301-.3V8.257c0-.214.054-.301.28-.301H5.05c.283 0 .322.108.319.349q-.003 3.856.003 7.701M5.77 2.87A2.885 2.885 0 1 1 0 2.9a2.885 2.885 0 0 1 5.77-.03" />
      </g>
      <defs>
        <clipPath id="LinkedIn_svg__a">
          <path fill="#fff" d="M0 0h24.066v24H0z" />
        </clipPath>
      </defs>
    </svg>
  );
};
export default LinkedIn;
